import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-cloud-configs',
  templateUrl: './cloud-configs.component.html',
  styleUrls: ['./cloud-configs.component.scss']
})
export class CloudConfigsComponent implements OnInit {

  isEdit = false;
  hostName = '';

  constructor(public dialogRef: MatDialogRef<CloudConfigsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private platform: LeftpanelComponent) { }

  ngOnInit() {
    if (this.data) {
      if (this.data.isEdit) {
        this.isEdit = true;
        if (this.data.config && this.data.config.host) {
          this.hostName = this.data.config.host;
        }
      }
    }
  }

  validateAndProceed() {
    Promise.resolve(this.getDomain(this.hostName)).then(domainName => {
      this.dialogRef.close({
        host: domainName
      });
    }, error => {
      this.platform.openSnackBar(error, 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  getDomain(value) {
    return new Promise((resolve, reject) => {

      try {
        const url = new URL(value);
        value = url.hostname;
      } catch (error) {
        // The value is not a valid URL, use it as is
      }

      // Extract the domain name from the value
      const domainRegex = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}$/i;
      let match = value.match(domainRegex);
      if (!match) {
        reject('Please provide a valid Domain name/ Host name / Host URL');
      }
      let domain = match[0];

      // Remove any path and query string components from the domain
      const pathRegex = /\/([^\/\?]+)/g;
      while (true) {
        match = pathRegex.exec(value);
        if (!match) {
          break;
        }
        domain += `/${match[1]}`;
      }

      // Return the domain name
      resolve(domain);
    });
  }

}
